// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // apiUrl: 'http://localhost:5080/api'
  apiUrl:'https://api.swasth.online/api',

  // Local build-version manifest, stamped at build time by
  // scripts/generate-version.js (see package.json "prebuild"). Fetched
  // cache-busted on every startup to detect a newly deployed build.
  versionManifestUrl: 'assets/version.json',

  // Optional server-driven update policy. Leave empty to disable remote
  // version checks entirely (local build-version detection still runs).
  remoteVersionConfigUrl: ''
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
